import { Anchor, Flex, Group, Stack, Text } from "@mantine/core";
import { useCallback, useMemo } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import MainTable from "../../../../../layouts/Table/MainTable";
import ItemDeleter from "../../../../../components/TableComponents/ItemDeleter";
import { useContactHandler } from "../../components/useContactHandler";
import { Link } from "react-router-dom";
import numberColumn from "../../../../../layouts/Table/columns/numberColumn";
import { useConfigStore } from "../../../../../stores/ConfigStore";
import {
  deleteBlacklistData,
  deleteBlacklistDatas,
  searchAllBlacklist,
} from "../../../../../api/BlacklistAPI";
import SelectionDeleter from "../../../../../components/TableComponents/SelectionDeleter";
import dateColumn from "../../../../../layouts/Table/columns/dateColumn";

function resultsHandler(response) {
  const datafields = useConfigStore.getState().datafields;
  let results = response;

  return results.map((data) => {
    let current_field = datafields.find((x) => x.id === data.data_field_id);

    if (current_field) {
      return {
        ...data,
        [current_field.id]: data.value,
      };
    }
    return {
      ...data,
    };
  });
}

const BlacklistsContentAll = () => {
  const lang = useLanguage((s) => s.language);
  const apiRef = useGridApiRef();

  const startingColumns = useMemo(
    () => [
      numberColumn(),
      dateColumn(),
      {
        field: "blacklist_id",
        id: "blacklist_id",
        headerName: lang.prm.details.campaigns_table.contact_list,
        filterable: false,
        sortable: false,
        width: 150,
        renderCell: ({ row, value }) => {
          return (
            <Anchor
              component={Link}
              to={`/blacklists/${value}`}
              target="_blank"
              c="inherit"
              fw={500}
              truncate="end"
            >
              {row.blacklist_name}
            </Anchor>
          );
        },
      },
    ],
    [lang.prm.details.campaigns_table.contact_list]
  );

  const {
    loading,
    columns,
    rows,
    rowCount,
    serverInfo,
    handleLoading,
    onFilterChange,
    onPaginationChange,
    onSortChange,
  } = useContactHandler({
    apiRef,
    getFirstPage: searchAllBlacklist,
    searchFunction: searchAllBlacklist,
    disableQueryTransform: true,
    resultsHandler,
    startingColumns,
  });

  const actionsCell = useCallback(
    ({ row, value }) => {
      return (
        <ItemDeleter
          title_bold={`#${row.id}`}
          handleDelete={deleteBlacklistData}
          deletedMessage={lang.blacklists.delete_success}
          parentId={row.blacklist_id}
          id={row.id}
          apiRef={apiRef}
        />
      );
    },
    [apiRef, lang.blacklists.delete_success]
  );

  const toolbarActions = useCallback(
    ({ selectedIds, filter }) => (
      <>
        <SelectionDeleter
          handleMultipleDelete={deleteBlacklistDatas}
          apiRef={apiRef}
          setTableLoading={() => handleLoading()}
          ids={selectedIds}
        />
      </>
    ),
    [apiRef, handleLoading]
  );

  const params = new URLSearchParams(location.search);
  const initialQuery = params.get("query");
  const initialFilter = params.get("filter");

  if (!columns) {
    return;
  }

  return (
    <Stack h={"100%"} flex={1} pr={16} gap={8} pt={12} miw={950}>
      <Group mt={4}>
        <Text fw={700} fz={24}>
          {lang.prospects.blacklist_contacts_all}
        </Text>
      </Group>

      <Flex h={0} flex={1} mt={10}>
        <MainTable
          isClient={false}
          apiRef={apiRef}
          columns={columns}
          rows={rows}
          rowCount={rowCount}
          loading={loading}
          setLoading={() => {
            handleLoading();
          }}
          id={"list-table"}
          hasFolder
          toolbarActions={toolbarActions}
          // pageName={"contact_lists_contacts"}
          onPaginationChange={onPaginationChange}
          actionsCell={actionsCell}
          onFilterChange={onFilterChange}
          onSortChange={onSortChange}
          // pageOrderName="contact_list_fetch_contacts_order"
          actionsCellWidth={50}
          withBorderTop
          whiteButtons
          defaultSearch={initialQuery}
          defaultFilter={initialFilter ? JSON.parse(initialFilter) : undefined}
          tableSx={{
            overflow: "hidden",
            "& .MuiDataGrid-pinnedColumns": {
              background: "#fff",
              borderTopLeftRadius: 3,
              border: "none",
            },
            "& .MuiDataGrid-pinnedColumnHeaders": {
              background: "#fff",
              border: "none",
            },
            "& .table-search": {
              width: "300px !important",
            },
          }}
        />
      </Flex>
    </Stack>
  );
};

export default BlacklistsContentAll;
